// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_ugk","cls2":"CiterightInfoBanner-cls2_rP3 CiterightInfoBanner-cls1_ugk"};